import { render, staticRenderFns } from "./journal-reports.vue?vue&type=template&id=e63ca8ba&"
import script from "./journal-reports.vue?vue&type=script&lang=js&"
export * from "./journal-reports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports